import React, {useState, useEffect} from 'react'
import {db, auth} from './firebase'
import './styles/loginPage.css'
import { Redirect } from 'react-router-dom'

export default function LoginPage() {
    const [loggedIn, setLoggedIn]=useState(false)


    const createUser=()=>{
        let name=document.querySelector("#handle").value
        let email=document.querySelector('#email').value
        let pass=document.querySelector('#password').value
        //alert (name)
        auth.createUserWithEmailAndPassword(email,pass)
        //console.log('user created')

        //creating the firebase for the new user
        db.collection(email).doc('data').set({
            handle:name,
        })
        alert('New user created')
        seeUser()
    }
    const login=()=>{
        let name=document.querySelector('#email').value
        let pass=document.querySelector('#password').value
        auth.signInWithEmailAndPassword(name,pass)
        alert('user logged in')

        seeUser()
    
    }

    //Keeping eye on user 
    const seeUser=()=>{
        auth.onAuthStateChanged((user)=>{
            if (user){
                console.log('user exists')
                setLoggedIn(true)
                
            }else{
                console.log('no user')
                setLoggedIn(false)
            }
        })
    }
    useEffect(()=>{seeUser()},[])
    //console.log(loggedIn)

    if(loggedIn){
        return(<Redirect to='/home'/>)
    }
    return (
        <div class="main_container">
            <h1>CodeForces <span>Hacked</span></h1>
            <div class="input_container">
                <label for="label" id="label">CF Handle</label>
                <input type="text" name="handle" id="handle"/>
                <label for="label" id="label">Email Address</label>
                <input type="email" name="email" id="email"/>
                <label for="label" id="label">Password</label>
                <input type="password" name="password" id="password"/>
                <div className="buttons">
                    <h6 id="button" onClick={createUser}>Create Account</h6>
                    <h6 id="button" onClick={login}>Login</h6>
                </div>
                
            </div>
        </div>
    

    )
}
